import { render, staticRenderFns } from "./No10.vue?vue&type=template&id=4e7c2220&scoped=true"
import script from "./No10.vue?vue&type=script&lang=js"
export * from "./No10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7c2220",
  null
  
)

export default component.exports